import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import SmoothScroll from "./components/SmoothScroll";
import ConsultationPopup from "./components/ConsultationPopup";
import PriceCalculator from "./components/PriceCalculator";
import ConstructionCalculator from "./components/ConstructionCalculator";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Interiors from "./pages/Interiors";
import Materials from "./pages/Materials";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="min-h-screen bg-[#0A0A0A]">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/interiors" element={<Interiors />} />
              <Route path="/materials" element={<Materials />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <FloatingButtons />
          <ConstructionCalculator />
          <PriceCalculator />
          <ConsultationPopup />
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#1A1A1A',
                color: '#fff',
                border: '1px solid rgba(255,255,255,0.1)',
              },
            }}
          />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
